import { useStation } from '@/store/station';
import { formatDateFromUnix } from '@/utils/date';

const Heading = ({ children }: { children: React.ReactNode }) => {
  return <span className='text-sm text-foreground-600 font-medium uppercase'>{children}</span>;
};

const Metadata = () => {
  const station = useStation.use.station();
  return (
    <div className='border border-default-200 rounded-md p-4'>
      <div className='flex items-center justify-between mb-3 border-b border-default-200 pb-2'>
        <h2 className='text-xl font-medium'>Additional Info</h2>
      </div>
      <div className='grid 2xl:grid-cols-2 gap-1 text-sm text-default-500'>
        <p className='flex items-center gap-2'>
          <Heading>Station ID:</Heading> {station?.id}
        </p>

        <p className='flex items-center gap-2'>
          <Heading>Created At:</Heading> {formatDateFromUnix(station?.createdAt as number)}
        </p>
        <p className='flex items-center gap-2'>
          <Heading>Updated At:</Heading> {formatDateFromUnix(station?.updatedAt as number)}
        </p>
      </div>
    </div>
  );
};

export default Metadata;
